
<template>
    <div>
        <helpInfo :helpData="helpData"></helpInfo>
        <Tabs v-model="tabVal"
              :animated="false"
              type="card"
              style="margin: 15px;">
            <TabPane v-for="nodeItem in tabPanes"
                     :key="nodeItem.nodeName"
                     :label="$t(nodeItem.nodeName)"
                     :name="nodeItem.nodeName">
                <ProcessInformation v-if="nodeItem.nodeName ==='处理信息'"
                                    :id="id"></ProcessInformation>
                <NodeInformation v-else
                                 :information="nodeItem"></NodeInformation>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import API from '@/service/api'
import helpInfo from '@c/basic/helpinfo'
import NodeInformation from '@/views/console/scalablefile/components/quotadetails/components/nodeInformation.vue'
import ProcessInformation from '@/views/console/scalablefile/components/quotadetails/components/processInformation.vue'
export default {
    name: 'quotadetails',
    components: {
        helpInfo,
        NodeInformation,
        ProcessInformation
    },
    data () {
        return {
            helpData: {
                modelName: '审批详情',
                showBack: true
            },
            id: this.$route.params.id,
            tabPanes: [],
            tabVal: 'information'
        }
    },
    created () {
        this.id = this.$route.params.id
        this.axios.get(this.urlFormat(API.PROCESS_ID_NOT_APPROVAL_NODES, true, [this.id])).then(res => {
            const tabPanes = [...res, { nodeName: '处理信息' }]
            this.tabPanes = tabPanes
            this.tabVal = tabPanes.nodeName
        })
    }
}
</script>
